import { Footer } from '@/components/Footer';
import { Navigation } from '@/components/Navigation';
import { useActiveSection } from '@/hooks/useActiveSection';
import { usePathname } from '@/hooks/usePathname';
import type { Route, NavSectionId } from '@/lib/constants';
import { parseRoute } from '@/lib/routing';
import { HomeRoute, PreviewRoute, PrivacyRoute, TermsRoute } from '@/routes';
import './index.css';

export function App() {
  const [pathname, setPathname] = usePathname();
  const { route, previewId } = parseRoute(pathname);
  const isHome = route === '/';

  const [activeSection, setActiveSection] = useActiveSection(isHome);

  const navigate = (to: Route) => {
    if (route === to) return;
    window.history.pushState({}, '', to);
    setPathname(to);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  };

  const handleSectionClick = (id: NavSectionId) => {
    setActiveSection(id);
  };

  const handleResetSection = () => {
    setActiveSection(null);
  };

  return (
    <div className="relative min-h-screen bg-black" id="top">
      <Navigation
        isHome={isHome}
        activeSection={activeSection}
        onNavigate={navigate}
        onSectionClick={handleSectionClick}
        onResetSection={handleResetSection}
        mobileMenuTrigger={null}
      />

      {route === '/preview' ? (
        <PreviewRoute previewId={previewId} onBackHome={() => navigate('/')} />
      ) : route === '/privacy' ? (
        <PrivacyRoute onBackHome={() => navigate('/')} />
      ) : route === '/terms' ? (
        <TermsRoute onBackHome={() => navigate('/')} />
      ) : (
        <HomeRoute />
      )}

      <Footer onNavigate={navigate} />
    </div>
  );
}

export default App;
